import { defineMessages } from "react-intl";

const messages = defineMessages({
  addChart: {
    id: "dashboard.header.org.menu.addChart",
    defaultMessage: "Add Chart",
    description: "Add chart menu item in Dashboard's header for the org scope",
  },
  addCompanyLogo: {
    id: "dashboard.header.org.image.noImagePlaceholder.editable",
    defaultMessage: "Add Your Company Logo",
    description:
      "A text to show when there's no org logo in Dashboard's header for the org scope, but current user can add one",
  },
  allTeamsUsers: {
    id: "dashboard.header.org.menu.applyOrgDashboardModal.allTeamsUsers",
    defaultMessage: "All teams and all users (including managers and owners)",
    description: "All teams and users options",
  },
  apply: {
    id: "dashboard.header.org.menu.apply",
    defaultMessage: "Apply",
    description: "Apply button",
  },
  applyOrgDashboard: {
    id: "dashboard.header.org.menu.applyOrgDashboard",
    defaultMessage: "Apply Org Dashboard to Teams",
    description: "Apply Org Dashboard to Teams button text",
  },
  applyOrgDashboardModalTitle: {
    id: "dashboard.header.org.menu.applyOrgDashboardModal.title",
    defaultMessage:
      "Are you sure? Any unique widgets configured on Team Dashboards will be replaced",
    description: "Apply Org Dashboard to Teams Modal Title",
  },
  applyToFollowing: {
    id: "dashboard.header.org.menu.applyOrgDashboardModal.applyToFollowing",
    defaultMessage: "Apply to the following:",
    description: "Apply to the following Title",
  },
  cancel: {
    id: "dashboard.header.org.menu.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button",
  },
  helpText: {
    id: "dashboard.header.org.menu.helpText",
    defaultMessage: "To replace, type “<b>Apply org dashboard to teams</b>” to continue",
    description: "Apply Org Dashboard to Teams Modal Help text",
  },
  manageUsers: {
    id: "dashboard.header.org.menu.manageUsersAndPermissions",
    defaultMessage: "Manage Users and Permissions",
    description: "Manage Users menu item in Dashboard's header for the org scope",
  },
  manageUsersTooltip: {
    id: "dashboard.header.org.tooltip.manageUsers",
    defaultMessage: "Manage Users",
    description: "Manage Users tooltip in Dashboard's header for the org scope",
  },
  modalDescription: {
    id: "dashboard.header.org.menu.applyOrgDashboardModal.description",
    defaultMessage:
      "The org dashboard configuration will be applied to all {allTeams, select, true {team dashboard configurations} other {selected teams above}}. <b>Existing team dashboards will be replaced and cannot be recovered.</b>",
    description: "Apply Org Dashboard to Teams Modal description",
  },
  noCompanyLogo: {
    id: "dashboard.header.org.image.noImagePlaceholder",
    defaultMessage: "No Company Logo",
    description: "A text to show when there's no org logo in Dashboard's header for the org scope",
  },
  orgPreferences: {
    id: "dashboard.header.org.menu.organizationPreferences",
    defaultMessage: "Organization Preferences",
    description: "Org Preferences menu item in Dashboard's header for the org scope",
  },
  selectTeams: {
    id: "dashboard.header.org.menu.applyOrgDashboardModal.selectTeams",
    defaultMessage: "Select Teams",
    description: "Select Teams",
  },
  specificTeams: {
    id: "dashboard.header.org.menu.applyOrgDashboardModal.specificTeams",
    defaultMessage: "Only specific teams",
    description: "Specific teams and users options",
  },
  usersCount: {
    id: "dashboard.header.org.numberOfUsers",
    defaultMessage: "{count} {count, plural, one {User} other {Users}}",
    description: "Number of users chip in Dashboard's header for the org scope",
  },
});

export default messages;
